import { render, staticRenderFns } from "./NeoparentTags.vue?vue&type=template&id=0b4189bd&scoped=true"
import script from "./NeoparentTags.vue?vue&type=script&lang=js"
export * from "./NeoparentTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4189bd",
  null
  
)

export default component.exports